import { Button, Card, Col, Row, Space, Statistic, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { IoAlertCircle, IoCall, IoCallOutline } from 'react-icons/io5'
import GroupsOffcanvas from '../../../core/common/offCanvas/groups/GroupsOffcanvas';
import { fetchTags } from '../../../core/data/redux/slices/TagSlice';
import { useDispatch } from 'react-redux';
import "./groups.scss"
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReloadOutlined } from '@ant-design/icons';

const Groups = () => {
    const { Title, Text } = Typography;
    const dispatch = useDispatch()
    const { tags: allTags, loading } = useSelector((state) => state.tags);
    const [searchQuery, setSearchQuery] = useState("");
    const [refreshing, setRefreshing] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(allTags.length === 0);

    useEffect(() => {
        if (!allTags.length) {
            dispatch(fetchTags()).then(() => setIsInitialLoad(false));
        } else {
            setIsInitialLoad(false);
        }
    }, [dispatch]);

    const handleRefresh = async () => {
        setRefreshing(true);
        setIsInitialLoad(true);
        await dispatch(fetchTags());
        setIsInitialLoad(false);
        setRefreshing(false);
    };
    const colors = ["#52c41a", "#1890ff", "#faad14", "#f5222d", "#722ed1"];
    const filteredTags = allTags?.filter((tagDetail) =>
        tagDetail.tag
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase())
    );
    useEffect(() => {
        if (!searchQuery) return;
    }, [searchQuery]);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="card">
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="page-header mb-0">
                                        <div className="row align-items-center">
                                            <h4 className="page-title mb-0">
                                                Groups
                                                <span className="count-title">
                                                    {allTags?.length}
                                                </span>
                                            </h4>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center'><div className="icon-form me-2 contacts-search-desktop">
                                        <span className="form-icon">
                                            <i className="ti ti-search" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search Groups"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />

                                    </div>
                                        <button
                                            className="btn btn-outline-secondary me-2"
                                            onClick={handleRefresh}
                                            disabled={refreshing || loading}
                                        >
                                            {refreshing ? (
                                                <span className="spinner-border spinner-border-sm me-1" />
                                            ) : (
                                                <ReloadOutlined className="me-1" />
                                            )}
                                            Refresh
                                        </button>
                                        <div>
                                            <Link
                                                to=""
                                                className="btn btn-primary contacts-add-btn"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#groups_offcanvas"
                                            >
                                                <i className="ti ti-square-rounded-plus" />
                                                <span className="ms-2">Add / Edit Group</span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="card p-3">

                   {isInitialLoad ? (
                        <Row gutter={[24, 0]} className="data-cards-row mb-4">
                            {Array.from({ length: 8 }).map((_, i) => (
                                <Col xs={24} sm={12} lg={6} key={i}>
                                    <Card
                                        className="metric-card inbound-card mb-4"
                                        styles={{ body: { padding: "24px" } }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                                                <div className="contact-skel" style={{ width: 28, height: 28, borderRadius: "50%", flexShrink: 0 }} />
                                                <div className="contact-skel" style={{ width: "55%", height: 16, borderRadius: 4, marginLeft: 12 }} />
                                            </div>
                                            <div className="contact-skel" style={{ width: 44, height: 32, borderRadius: 6, flexShrink: 0, marginLeft: 8 }} />
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                   ) : <> {filteredTags?.length === 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "64px 24px", textAlign: "center" }}>
                          <div style={{ width: 80, height: 80, borderRadius: "50%", background: searchQuery ? "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)" : "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                            <i className={searchQuery ? "ti ti-filter-off" : "ti ti-tags"} style={{ fontSize: 36, color: searchQuery ? "#d97706" : "#3C2371" }} />
                          </div>
                          <h5 style={{ fontWeight: 700, marginBottom: 8, color: "#111827" }}>
                            {searchQuery ? "No groups match your search" : "No groups yet"}
                          </h5>
                          <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24, maxWidth: 320 }}>
                            {searchQuery
                              ? "Try a different search term or clear the search to see all groups."
                              : "Groups help you segment your contacts and leads. Create your first group to get started."}
                          </p>
                          {searchQuery ? (
                            <button className="btn btn-outline-secondary" style={{ borderRadius: 8, padding: "10px 24px", fontWeight: 600, fontSize: 14 }} onClick={() => setSearchQuery("")}>
                              <i className="ti ti-x me-2" />Clear Search
                            </button>
                          ) : (
                            <Link to="" className="voycell-empty-btn" data-bs-toggle="offcanvas" data-bs-target="#groups_offcanvas">
                              <i className="ti ti-square-rounded-plus" />
                              Create Your First Group
                            </Link>
                          )}
                        </div>
                    ) :
                        <Row gutter={[24, 0]} className="data-cards-row mb-4">
                            {
                                filteredTags?.map((tagDetail, index) => {
                                    return (
                                        <Col xs={24} sm={12} lg={6} key={index}>
                                            <Card
                                                className="metric-card inbound-card mb-4"
                                                hoverable
                                                styles={{
                                                    body: { padding: "24px" },
                                                }}>
                                                <Space
                                                    direction="vertical"
                                                    size="small"
                                                    style={{ width: "100%" }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                        }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flex: 1,
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            <div>{tagDetail.emoji}</div>

                                                            <Text
                                                                type="secondary"
                                                                ellipsis={{ tooltip: tagDetail.tag }}
                                                                style={{
                                                                    marginLeft: 12,
                                                                    fontSize: "1rem",
                                                                    flex: 1,
                                                                    minWidth: 0,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {tagDetail.tag}
                                                            </Text>
                                                        </div>
                                                        <Statistic
                                                            value={tagDetail?.totalCount}
                                                            precision={0}
                                                            valueStyle={{
                                                                color: colors[index % colors.length],
                                                                fontSize: "28px",
                                                                flexShrink: 0,
                                                            }}
                                                        />
                                                    </div>
                                                </Space>
                                            </Card>

                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    }
                    </>}
                </div>
            </div>
            <GroupsOffcanvas />
        </div>
    )
}

export default Groups